.wrapper {
    display: inline-flex;
    gap: 12px;
    background: var(--color-white);
    padding: 8px;
    cursor: pointer;
    border-radius: 8px;
    width: auto;
}

.wrapper.disabled {
    background: #F7F7F7;
    cursor: default;
}

.group {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.icon {
    display: flex;
}

.icon svg {
    width: 16px;
    height: 16px;
    margin: auto;
}

.icon svg * {
    fill: var(--color-lilac-dark);
}

.label {
    font-size: 12px;
    color: var(--color-lilac-dark);
}

.input {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    color: var(--color-lilac-dark);
    white-space: nowrap;
    overflow: hidden;
}

.inWidjet .input {
    width: 155px;
    overflow: hidden;
    text-overflow: ellipsis;
}

@keyframes spin {
    100% {
        transform: rotate(360deg)
    }
}

.loader {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
}

.loader svg {
    width: 19px;
    height: 19px;
    animation: 1.5s infinite linear spin;
}

.insideModule {
    height: calc(40 / 16 * 1rem);
    padding: 0;
    display: flex;
    gap: calc(10 / 16 * 1rem);
    width: calc(211 / 16 * 1rem);
    border: calc(1 / 16 * 1rem) solid #f0f0f0;
    border-radius: 1rem;
    overflow: hidden;
    min-width: 0;
    max-width: none;
}

.insideModule .icon {
    width: calc(42 / 16 * 1rem);
    height: calc(40 / 16 * 1rem);
    flex-shrink: 0;
    background: #f0f0f0;
}

.insideModule .icon svg {
    width: 1rem;
    height: 1rem;
}

.insideModule .label {
    font-size: calc(10 / 16 * 1rem);
    font-weight: normal;
}

.insideModule .input {
    font-size: calc(14 / 16 * 1rem);
    font-weight: 500;
}

.insideModule .group {
    justify-content: center;
}

@media (max-width: 768px) {
    .insideModule .group {
        padding: 0 1rem;
    }
}